// Parse simples de User-Agent (sem lib nova) — usado pela aba LOGS
// (notificação push ativada em qual aparelho) e pela aba DISPOSITIVOS
// CONECTADOS (Editar Usuário). Não precisa ser exaustivo, só dar um rótulo
// legível.
export function describeUserAgent(ua: unknown): string | null {
  if (typeof ua !== "string" || !ua) return null;
  const platform = /iphone|ipad|ipod/i.test(ua)
    ? "iPhone/iPad"
    : /android/i.test(ua)
      ? "Android"
      : /windows/i.test(ua)
        ? "Windows"
        : /mac os/i.test(ua)
          ? "Mac"
          : "Dispositivo";
  const browser = /edg\//i.test(ua)
    ? "Edge"
    : /chrome\//i.test(ua)
      ? "Chrome"
      : /firefox\//i.test(ua)
        ? "Firefox"
        : /safari\//i.test(ua)
          ? "Safari"
          : "navegador";
  return `${platform} — ${browser}`;
}
